'use client';

import { useEffect, useState } from 'react';
import { apiFetch } from '@/platform/lib/api';
import { isFacebookLoginEnvOverride } from './facebookLoginEnabled';

type Status = {
  enabled: boolean;
  loading: boolean;
};

/** Whether to show Facebook Login — env override, else Meta approval via API. */
export function useFacebookLoginEnabled(): Status {
  const envOverride = isFacebookLoginEnvOverride();
  const [enabled, setEnabled] = useState(envOverride === true);
  const [loading, setLoading] = useState(envOverride === null);

  useEffect(() => {
    if (envOverride === true) {
      setEnabled(true);
      setLoading(false);
      return;
    }
    if (envOverride === false) {
      setEnabled(false);
      setLoading(false);
      return;
    }

    let cancelled = false;
    apiFetch<{ enabled: boolean }>('/auth/facebook-login-status')
      .then((res) => {
        if (!cancelled) setEnabled(!!res.enabled);
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [envOverride]);

  return { enabled, loading };
}
